<template>
  <div id="contenedor-usuarios-main">
    <v-container fluid>
      <v-card
        class="mb-4"
        flat>
        <v-card-text>
          <titulo-tool-bar></titulo-tool-bar>
          <tool-bar
            v-on:nuevoUsuario="registrarUsuario"
            v-on:buscar="setBuscarTexto"
            >
          </tool-bar>
        </v-card-text>
      </v-card>
      <router-view />
    </v-container>
    <!-- CUADRO DE DIALOGO EDITAR -->
    <v-dialog
      v-model="mostrarVentanaRegistrarUsuario"
      scrollable
      :width="!$vuetify.breakpoint.mobile ? '600' : '90%'">
      <RegistrarNuevoUsuario></RegistrarNuevoUsuario>
    </v-dialog>
    <!-- REGISTRAR USUARIO CONTRATISTA -->
    <v-dialog
      v-if="mostarRegistrarUsuarioContratista"
      v-model="mostarRegistrarUsuarioContratista"
      scrollable
      :width="!$vuetify.breakpoint.mobile ? '600' : '90%'">
      <v-card>
        <v-card-title class="secondary--text">
          Registrar Usuario Contratista
          <v-spacer></v-spacer>
          <v-btn icon @click="mostarRegistrarUsuarioContratista=false">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider class="mx-2"></v-divider>
        <v-card-text>
          <RegistrarUsuarioContratista
          ref="registrarUsuarioContratista"
          v-on:cerrar="cerrarRegistrarUsuario">
          </RegistrarUsuarioContratista>
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="mostarRegistrarUsuarioContratista = false"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="$refs.registrarUsuarioContratista.registrar()"
            tipo="formAceptar"
            label="Guardar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ACTUALIZAR USUARIO CONTRATISTA -->
    <v-dialog
      v-if="esteUsuario"
      v-model="mostarEditarUsuarioContratista"
      scrollable
      :width="!$vuetify.breakpoint.mobile ? '600' : '90%'">
      <v-card>
        <v-card-title class="secondary--text">
          Editar Usuario Contratista
          <v-spacer></v-spacer>
          <v-btn icon @click="mostarEditarUsuarioContratista=false">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider class="mx-2"></v-divider>
        <v-card-text>
          <EditarUsuarioContratista
          ref="editarUsuarioContratista"
          :usuarioContratistaEditar="esteUsuario"
          v-on:cerrar="cerrarEditarUsuarioContratista">
          </EditarUsuarioContratista>
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="mostarEditarUsuarioContratista = false"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="$refs.editarUsuarioContratista.actualizar()"
            tipo="formAceptar"
            label="Actualizar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog persistent
      v-if="esteUsuario"
      v-model="mostrarVentanaEditarUsuario"
      :width="!$vuetify.breakpoint.mobile ? '600' : '90%'">
      <editar-usuario
        :usuarioEditar="esteUsuario"
        v-on:cerrar="cerrarEditarUsuario">
      </editar-usuario>
    </v-dialog>
    <!-- CUADRO DE DIALOGO ELIMINAR -->
    <v-dialog persistent
      v-if="esteUsuario"
      v-model="mostrarVentanaEliminarUsuario"
      :width="!$vuetify.breakpoint.mobile ? '450' : '90%'">
      <eliminar-usuario
        :usuarioEliminar="esteUsuario"
        v-on:cerrar="cerrarEliminarUsuario">
      </eliminar-usuario>
    </v-dialog>
  </div>
</template>

<script>
import eventBus from '@/helpers/eventBus';
import RegistrarNuevoUsuario from '@/components/administracion/configuracion/catalogos/usuarios/Nuevo.vue';
import EditarUsuario from '@/components/administracion/configuracion/catalogos/usuarios/Editar.vue';
import EliminarUsuario from '@/components/administracion/configuracion/catalogos/usuarios/Eliminar.vue';
import RegistrarUsuarioContratista from '@/components/administracion/configuracion/catalogos/usuarios/RegistrarUsuarioContratista.vue';
import EditarUsuarioContratista from '@/components/administracion/configuracion/catalogos/usuarios/EditarUsuarioContratista.vue';
import TituloToolBar from './TituloToolBar.vue';
import ToolBar from './ToolBar.vue';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'UsuariosMain',
  components: {
    RegistrarNuevoUsuario,
    RegistrarUsuarioContratista,
    EditarUsuarioContratista,
    EditarUsuario,
    EliminarUsuario,
    ToolBar,
    TituloToolBar,
    CustomButton,
  },
  data() {
    return {
      mostrarVentanaRegistrarUsuario: false,
      mostarRegistrarUsuarioContratista: false,
      mostarEditarUsuarioContratista: false,
      mostrarVentanaEditarUsuario: false,
      mostrarVentanaEliminarUsuario: false,
      esteUsuario: null,
      buscarTexto: null,
    };
  },
  mounted() {
    eventBus.$on('editar-usuario', (usuario) => {
      this.esteUsuario = usuario;
      this.mostrarVentanaEditarUsuario = true;
    });
    eventBus.$on('editar-usuario-contratista', (usuario) => {
      this.esteUsuario = usuario;
      this.mostarEditarUsuarioContratista = true;
    });
    eventBus.$on('eliminar-usuario', (usuario) => {
      this.esteUsuario = usuario;
      this.mostrarVentanaEliminarUsuario = true;
    });
  },
  methods: {
    setBuscarTexto(buscarTexto) {
      this.buscarTexto = buscarTexto;
    },
    registrarUsuario() {
      const { name } = this.$route;

      if (name === 'catalogoUsuarios') {
        this.mostrarVentanaRegistrarUsuario = true;
      } else {
        this.mostarRegistrarUsuarioContratista = true;
      }
    },
    cerrarEditarUsuarioContratista() {
      this.mostarEditarUsuarioContratista = false;
      this.esteUsuario = null;
    },
    cerrarEditarUsuario() {
      this.mostrarVentanaEditarUsuario = false;
      this.mostarRegistrarUsuarioContratista = false;
      this.esteUsuario = null;
    },
    cerrarEliminarUsuario() {
      this.mostrarVentanaEliminarUsuario = false;
      this.esteUsuario = null;
    },
  },
};
</script>

<style lang="scss">

</style>
